document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('media-gallery').forEach(function (gallery) {
    const slider = gallery.querySelector('[id^="Slider-Gallery"]');
    const previousButton = gallery.querySelector('.custom-gallery-prev');
    const nextButton = gallery.querySelector('.custom-gallery-next');

    if (!slider || !previousButton || !nextButton) return;

    function getSlides() {
      return Array.from(slider.querySelectorAll('[data-media-id]'));
    }

    function getCurrentIndex() {
      const slides = getSlides();

      let activeIndex = slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });

      if (activeIndex !== -1) return activeIndex;

      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        const distance = Math.abs(slider.scrollLeft - slide.offsetLeft);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function showImage(index) {
      const slides = getSlides();

      if (!slides.length) return;

      const finalIndex = (index + slides.length) % slides.length;
      const targetSlide = slides[finalIndex];
      const mediaId = targetSlide.dataset.mediaId;

      slides.forEach(function (slide) {
        slide.classList.remove('is-active');
      });

      targetSlide.classList.add('is-active');

      if (typeof gallery.setActiveMedia === 'function' && mediaId) {
        gallery.setActiveMedia(mediaId, false);
      } else {
        slider.scrollTo({
          left: targetSlide.offsetLeft,
          behavior: 'smooth',
        });
      }
    }

    previousButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      showImage(getCurrentIndex() - 1);
    });

    nextButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      showImage(getCurrentIndex() + 1);
    });
  });
});